export enum IdentityType {
  COMPANY = 'COMPANY',
  INDIVIDUAL = 'INDIVIDUAL',
}
